import { Navigate, Route, Routes } from "react-router-dom";
import Header from "../Header/Header";
import AsideRateshop from "./AsideRateshop";
import React from "react";
import Loader from "../Loader/Loader";
import { commonService } from "../../utils/commonService";
import { useSelector } from "react-redux";
const RSCompsetVariance = React.lazy(() => import("./RSCompsetVariance"));
const RSRateShopTableView = React.lazy(() => import("./RSRateShopTableView"));
const PropertySetting = React.lazy(() => import("../RevenueManagement/PropertySetting"));
const RSRateShop = React.lazy(() => import("./RSRateShop"));
const RSBenchMarking = React.lazy(() => import("./RSBenchMarking"));
const RSPerityCheck = React.lazy(() => import("./RSPerityCheck"));
const RSRateShopPayment = React.lazy(() => import("./RSRateShopPayment"));

function LayoutRateshop() {
    const token = commonService.getItem("token");
    const sidebarOpen = useSelector(
        (store) => store.headerProperty.isSidebarOpen
    );
    return (
        <div className={`mainRoot ${sidebarOpen ? "full-menu" : "icon-toggle-menu"}`} >
            <Header />
            <AsideRateshop />
            <main
                className={`config-page-body container-data-load`}
            >
                <Routes>
                    <Route
                        path="/property-setting/:id"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <PropertySetting />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <RSRateShop />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                    <Route
                        path="/dashboard-list"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <RSRateShopTableView />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                    <Route
                        path="/paritycheck"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <RSPerityCheck />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                    <Route
                        path="/benchmarking"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <RSBenchMarking />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                    <Route
                        path="/compsetvariance"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <RSCompsetVariance />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                    <Route
                        path="/rateshop-payment"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <RSRateShopPayment />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                </Routes>
            </main>
        </div>
    );
}

export default LayoutRateshop;
